/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/**
 * Helper module for evaluating environment variables.
 * Uses next-runtime-env package to get environment variables from either the
 * browser window or the server environment.
 */
import { get } from 'lodash'
import { env } from 'next-runtime-env'
// eslint-disable-next-line no-restricted-imports
import type { EnvVariable } from '../../env'

export const { LIGHTHOUSE_INTERNAL_BASE_URL, FAROS_INTERNAL_API_URL } =
  process.env

export const IS_DEVELOPMENT_ENVIRONMENT = process.env.NODE_ENV === 'development'

export const getEnv = (key: keyof EnvVariable) => {
  return env(key)
}

export const getEnvOrThrow = (key: keyof EnvVariable) => {
  const value = env(key)
  if (value) {
    return value
  }
  throw new Error(`Missing env variable "${key}"`)
}

// Can be used instead of getEnvOrThrow for server-only code
export const getServerEnv = (key: keyof EnvVariable) => {
  const value = get(process.env, key)
  if (value) {
    return value
  }
  throw new Error(`Missing server env variable "${key}"`)
}

export const getEnvVariables = <TKeys extends Array<keyof EnvVariable>>(
  keys: [...TKeys]
) => {
  return keys.map(getEnvOrThrow) as {
    [TKey in keyof TKeys]: string
  }
}

export const getAionApiUrl = () =>
  process.env.AION_API_URL ?? getEnvOrThrow('NEXT_PUBLIC_FAROS_API_URL')

export const IS_STATIC_AUTH_ENABLED: boolean =
  getEnv('NEXT_PUBLIC_ENABLE_STATIC_AUTH') === 'true'

export const IS_METABASE_EXTERNAL_HOST: boolean =
  (getEnv('NEXT_PUBLIC_METABASE_EXTERNAL_HOST') || 'true') !== 'false'
